import zfetch, { METHOD_GET } from '../pages/common/utils/zfetch';
import {
  GET_CONSUMPTION_DETAILS,
  GET_ORDER,
  GET_ORDERS_INSIGHTS,
  GET_ORDER_INVOICE,
} from '../constants/urls';

const getOrderByOrderId = orderId => {
  const options = {
    method: METHOD_GET,
    params: {
      order_id: orderId,
    },
  };
  return zfetch(GET_ORDER, options).then(res => res.json());
};

const getOrdersForDownload = (
  startDate,
  endDate,
  orderStatus,
  businessType,
) => {
  const options = {
    method: METHOD_GET,
    params: {
      start_date: startDate,
      end_date: endDate,
      order_status: orderStatus,
      business_type: businessType,
    },
  };
  return zfetch(GET_CONSUMPTION_DETAILS, options).then(res => res.json());
};

const getOrdersInsights = (companyId, startDate, endDate) => {
  const options = {
    method: METHOD_GET,
    params: {
      company_id: companyId,
      start_date: startDate,
      end_date: endDate,
    },
  };
  return zfetch(GET_ORDERS_INSIGHTS, options).then(res => res.json());
};

const getOrderInvoice = orderId => {
  const options = {
    method: METHOD_GET,
    params: {
      order_id: orderId,
    },
  };
  return zfetch(GET_ORDER_INVOICE, options).then(res => res.json());
};

export { getOrderByOrderId, getOrdersForDownload, getOrdersInsights, getOrderInvoice };
